import { createRequestHelper } from '../../common';
export const createContractRequest = createRequestHelper();
